import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { ParametrizarParametrosIndexComponent } from './ParametrizarParametrosIndex.component';
import { ParametrizarParametrosEdit } from './ParametrizarParametrosEdit.component';
import { DialogConfirmacion } from './ParametrizarParametrosIndex.component';
 
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';

const routes = [
    {
        path     : 'ParametrizarParametros',
        component: ParametrizarParametrosIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ParametrizarParametros',
          nombreFormulario : 'ParametrizarParametros'
        } 
    }, 
    {
        path     : 'ParametrizarParametros/:nanno',
        component: ParametrizarParametrosEdit,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ParametrizarParametros',
          nombreFormulario : 'Editar Parametros'
        } 
    }
    
    
];

@NgModule({
    declarations: [
        ParametrizarParametrosIndexComponent,
        ParametrizarParametrosEdit,
        DialogConfirmacion
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ParametrizarParametrosIndexComponent,
        ParametrizarParametrosEdit
    ],
    bootstrap: [ParametrizarParametrosIndexComponent, DialogConfirmacion],
})

export class   ParametrizarParametrosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ParametrizarParametros/ParametrizarParametrosModule.module.ts